import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Container,   
  useTheme,
  useMediaQuery,
  Alert,
  LinearProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../utils/colors';
import logo from '../../assets/Binan.jpeg';
import { loginAPI } from '../../lib/api';
  
const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('authToken');
      const user = localStorage.getItem('user');
      if (token && user) {
        navigate('/dashboard');
      }
    }; 
    checkAuth();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await loginAPI(email, password);

      if (result.data) {
        localStorage.setItem('authToken', result.data.token || '');
        localStorage.setItem('user', JSON.stringify(result.data.user || {}));
        navigate('/dashboard');
      } else {
        setError('Login failed: No token received');                         
      }
    } catch (error) {
      setError(error.message);
      console.error('Login error:', error);
    } finally {                            
      setLoading(false);
    }
  };

  return (
    <Container
      component="main"
      maxWidth="sm"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 3
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 400,
          borderRadius: 2
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              mb: 3
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{
                width: isMobile ? 80 : 150,
                height: isMobile ? 80 : 150,
                mb: 2,
                objectFit: 'contain', 
                p: 1.5,
              }}
            />
            <Typography
              component="h1"
              variant="h5"
              sx={{
                fontWeight: 600,
                color: colors.primary.main,
                textAlign: 'center'
              }}
            >
              Sign In
            </Typography>
          </Box>
          
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ width: '100%' }}
          >
            <TextField
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              variant="outlined"
              sx={{ mb: 2 }}
            />
            
            <TextField
              fullWidth
              id="password"
              label="Password"
              name="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              variant="outlined"
              sx={{ mb: 3 }}
            />
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                mt: 2,
                mb: 2,
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 600,
                bgcolor: colors.primary.main,
                '&:hover': {
                  bgcolor: colors.primary.hover
                },
                '&:disabled': {
                  bgcolor: colors.primary.main,
                  opacity: 0.7
                }
              }}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default SignIn;



